import { getApi } from '../../api';
import { orders } from '../../endpoints';

export async function convertBudgetToOrderApi(orderNumber: number | string) {
  const api = await getApi();
  return api.post(`${orders['']}/${encodeURIComponent(String(orderNumber))}/convert-budget-to-order`);
}
